import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: ${COLOR.WHITE_1};
  padding: 18px 24px;
  max-width: 628px;
  margin-left: auto;
  margin-right: auto;
  h1, h3 {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: ${COLOR.GREY_1};
  }
  h3 {
    margin-top: 32px;
    margin-bottom: 24px;
  }
`;

export const BoxHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  h2 {
    padding: 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-weight: 500;
    font-size: 16px;
    color: ${COLOR.GREY_1};
    line-height: 1.4;
    border-bottom: 1px solid ${COLOR.GREY_3};
    span {
      font-size: 20px;
      color: ${COLOR.GREEN_1};
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: ${COLOR.GREY_1};
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    span{
      font-weight: 500;
    }
    label {
      font-size: 14px;
      color: ${COLOR.GREEN_1};
      margin-left: 8px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  img {
    width: 103px;
    height: 24px;
    margin: 17px auto;
  }
  .MuiIconButton-label {
    font-size: 16px;
    text-decoration: underline;
  }
  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
    margin-left: 4px;
  }
  .MuiIconButton-root {
    position: absolute;
    top: 0;
    right: 0;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    h1 {
      font-size: 20px;
    }
    h2 {
      font-size: 18px;
    }
    p { 
      font-size: 16px;
    }
    .MuiIconButton-label {
      font-size: 18px;
    }
  }
  
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    h1 {
      font-size: 22px;
    }
    h2 {
      font-size: 20px;
    }
    p { 
      font-size: 18px;
    }
    .MuiIconButton-label {
      font-size: 20px;
    }
  }
`;

export const Cards = styled.div`
  display: ${({ loadingPage }) => loadingPage && 'none'};
  width: 100%;
  height: auto;
  margin: 0px;
  form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .MuiFormControl-root {
      margin: 14px 0 0 0;
    }
  }
  p {
    text-align: center;
  }
  button{
    align-items: center;
  }
  h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
  }
`;

export const BoxOptin = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 32px 0 24px 0;
  span {
    padding-left: 0;
  }
  label {
    font-size: 16px;
    color: ${COLOR.GREY_1};
    line-height: 125%;
  }
`;

export const GroupInputsCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BoxCoupon = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 24px;
  padding-bottom: 24px;
  margin-bottom: 30px;
  border-bottom: 1px solid ${COLOR.GREY_3};
  p {
    font-weight: 600;
    font-size: 16px;
    color: ${({ coupon }) => (coupon ? COLOR.GREY_1 : COLOR.GREEN_1)};
    text-decoration: underline;
    margin-bottom: ${({ coupon }) => (coupon ? '14px' : '0')};;
    cursor: pointer;
  }
  div {
    display: ${({ coupon }) => (coupon ? 'flex' : 'none')};
    width: 100%;
    .MuiFormControl-root {
      width: 80%;
      margin: 10px 0 0 0;
      height: 45px;
      .MuiInputBase-root {
        border-radius: 6px 0 0 6px;
      }
    }
    button {
      width: 20% !important;
      margin: 10px 0 0 0;
      height: 45px;
      border-radius: 0 6px 6px 0;
    }
  }
    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      p {
        font-size: 18px;
      }
    }
    /* Desktop */
    @media screen and (min-width: ${BREAKPOINT.LG}) {
      p {
        font-size: 20px;
      }
    }
`;

export const MessageCoupon = styled.label`
  font-size: 14px;
  margin-top: 10px;
  color: ${COLOR.GREEN_1};
  font-weight: 500;

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 16px;
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 18px;
  }
`;

export const FormWrapper = styled.div`
  padding-bottom: 35px;
  border-bottom: 1px solid ${COLOR.GREY_3};
  legend {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .Mui-checked + span {
    font-weight: 600;
  }
  .MuiTypography-root {
    font-size: 14px;
  }
`;

export const KitWrapper = styled.div`
  min-width: 290px;
  height: 138px;
  margin: 8px auto;
  padding: 14px;
  background-color: #F5F5F5;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1.4;
  overflow-y: scroll;
  a {
    text-decoration: underline;
    color: ${COLOR.GREEN_1};
    font-weight: 500;
  }
  p {
    margin-bottom: 14px;
  }
`;

export const ResumeLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0 0;
`;

export const BuyResume = styled.div`
`;

export const Resume = styled.div`
  p {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    span {
      font-weight: 500;
    }
  }

  label {
    margin-left: 5px;
    text-decoration: underline;
    cursor: pointer;
    color: ${COLOR.RED_3};
    font-weight: 500;
  }
`;
